import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import ToggleButtonListItem from '../../../../../list-items/ToggleButtonListItem';

const spectrumOptions = [
    {value: 'bass spectrum', text: 'Bass'},
    {value: 'wide spectrum', text: 'Wide'}
];

const VisualizerSpectrumListItem = (props) => {
    const { visualizerWaveType, updateVisualizerSettings } = props;
    
    const onSpectrumChange = (value) => {
        updateVisualizerSettings({ waveType: value });
    };
    
    return (
        <ToggleButtonListItem
            text='Spectrum'
            value={visualizerWaveType}
            onChange={onSpectrumChange}
            options={spectrumOptions}
            toolTip={
                <>
                    <p>BASS: Visualize low frequencies.</p>
                    <p>WIDE: Visualize a wide range of frequencies.</p>
                </>
            }
        />
    );
};

const mapStateToProps = (state) => {
    const { waveType: visualizerWaveType } = state.createPreview.present.videoSettings.visualizer;
    return { visualizerWaveType };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerSpectrumListItem);